import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3328df99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row pb-1" }
const _hoisted_2 = { class: "row pb-1" }
const _hoisted_3 = { class: "row pb-1" }
const _hoisted_4 = { class: "row pb-1" }
const _hoisted_5 = { class: "row pb-1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Plain")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Rich")
const _hoisted_8 = {
  key: 1,
  class: "editor"
}
const _hoisted_9 = { class: "row ml-1 pb-1" }

import { ContractActivity } from "@/models/ContractActivity";
import { computed, defineComponent, ref, reactive } from "vue";
import { DataParameter } from "@/models/ContractActivity";
import Editor from "@tinymce/tinymce-vue";
import LevelSelector from "./LevelSelector.vue";
import { ProtocolLevel } from "@/notifi_types";

/* global defineProps, defineEmits */

export default /*#__PURE__*/_defineComponent({
  props: {
  contractActivity: { type: ContractActivity, required: false },
},
  emits: ["activityUpdate", "activityAdd", "activityDelete"],
  setup(__props, { emit }) {

const props = __props




// eslint-disable-next-line vue/no-setup-props-destructure
let newAct: ContractActivity = props.contractActivity;
if (!props.contractActivity) {
  newAct = new ContractActivity();
}
const activity = ref<ContractActivity>(newAct);

const intName = ref<string>("");

const textType = ref<"plain" | "rich">("plain");

const ABIfailed = ref(false);
const ABIerrors = ref<string[]>([]);

const activeActivity = computed((): ContractActivity => {
  return activity.value;
});
const newRecord = computed((): boolean => {
  return props.contractActivity == undefined;
});
const name = computed({
  get(): string {
    return activity.value.name;
  },
  set(newVal: string): void {
    activity.value.name = newVal;
    emit("activityUpdate", activity.value);
  },
});
const description = computed({
  get(): string {
    return activity.value.description;
  },
  set(newDescription: string): void {
    activity.value.description = newDescription;
    emit("activityUpdate", activity.value);
  },
});
const topic = computed({
  get(): string {
    return activity.value.topic;
  },
  set(newTopic: string): void {
    activity.value.topic = newTopic;
    emit("activityUpdate", activity.value);
  },
});
const abi = computed({
  get(): string {
    return activity.value.ABI;
  },
  set(newABI: string): void {
    ABIfailed.value = false;
    try {
      JSON.parse(newABI);
    } catch (err: any) {
      ABIfailed.value = true;
      ABIerrors.value = ["Parse Failed-" + err.message];
      return;
    }
    ABIfailed.value = false;
    ABIerrors.value = [];
    activity.value.ABI = newABI;
    emit("activityUpdate", activity.value);
  },
});
const level = computed({
  get(): string {
    return activity.value.level;
  },
  set(newVal: string): void {
    activity.value.level = newVal as ProtocolLevel;
    if (!newRecord.value) {
      activity.value.save();
    }
  },
});
const template = computed({
  get(): string {
    return activity.value.template;
  },
  set(newVal: string): void {
    activity.value.template = newVal;
    emit("activityUpdate", activeActivity.value);
  },
});
const richTemplate = computed({
  get(): string {
    return activity.value.richTemplate;
  },
  set(newVal: string): void {
    activity.value.richTemplate = newVal;
    emit("activityUpdate", activeActivity.value);
  },
});
const dataParameters = computed((): DataParameter[] => {
  return activeActivity.value.dataParameters;
});
const addAllowed = computed((): boolean => {
  return (
    validName.value &&
    validDescription.value &&
    validTopic.value &&
    validABI.value &&
    validTemplate.value &&
    validLevel.value
  );
});
const validName = computed((): boolean => {
  return (name.value || "").length > 3;
});
const validTopic = computed((): boolean => {
  return (topic.value || "").length > 3;
});
const validLevel = computed((): boolean => {
  return level.value !== "";
});
const validABI = computed((): boolean => {
  return true;
});
const validDescription = computed((): boolean => {
  return true;
});
const validTemplate = computed((): boolean => {
  return true;
});

const add = (): void => {
  emit("activityAdd", activity.value);
  activity.value = reactive(new ContractActivity());
};

const destroy = (): void => {
  activeActivity.value.destroy();
  emit("activityDelete", activeActivity.value);
};
const parameterClick = (param: DataParameter): void => {
  console.log(`Click on ${param.name}`);
  const cur = activeActivity.value.template || "";
  template.value = `${cur}{{${param.name}}}`;
};
const setLevel = (aLevel: string): void => {
  level.value = aLevel;
};

return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_chip = _resolveComponent("va-chip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_va_input, {
        class: "flex sm10",
        label: "Name",
        modelValue: _unref(name),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null))
      }, null, 8, ["modelValue"]),
      (_unref(newRecord))
        ? (_openBlock(), _createBlock(_component_va_button, {
            key: 0,
            icon: "add",
            size: "small",
            disabled: !_unref(addAllowed),
            onClick: add
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (!_unref(newRecord))
        ? (_openBlock(), _createBlock(_component_va_button, {
            key: 1,
            icon: "delete",
            size: "small",
            onClick: destroy
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_va_input, {
        class: "flex sm12",
        label: "Description",
        textarea: "",
        modelValue: _unref(description),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(description) ? (description).value = $event : null))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_va_input, {
        class: "flex sm12",
        label: "Topic",
        placeholder: "Transfer(address, address, uint256)",
        modelValue: _unref(topic),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(topic) ? (topic).value = $event : null))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_va_input, {
        class: "flex sm12",
        label: "ABI",
        type: "textarea",
        error: ABIfailed.value,
        "error-messages": ABIerrors.value,
        "min-rows": 4,
        modelValue: _unref(abi),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(abi) ? (abi).value = $event : null))
      }, null, 8, ["error", "error-messages", "modelValue"])
    ]),
    _createVNode(LevelSelector, {
      onChanged: setLevel,
      startingLevel: _unref(level)
    }, null, 8, ["startingLevel"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_va_tabs, {
        modelValue: textType.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((textType).value = $event))
      }, {
        tabs: _withCtx(() => [
          _createVNode(_component_va_tab, { name: "plain" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_va_tab, { name: "rich" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (textType.value == 'plain')
        ? (_openBlock(), _createBlock(_component_va_input, {
            key: 0,
            class: "flex sm12",
            label: "Plain Message Template",
            type: "textarea",
            "min-rows": 6,
            autosize: "",
            modelValue: _unref(template),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(template) ? (template).value = $event : null)),
            placeholder: "This is an alert for [[user]] triggered from [[contract]]"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (textType.value == 'rich')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_unref(Editor), {
              "api-key": "582k9lowpc19oacd180hsqwlq73pavp5uvuet95zgras454q",
              modelValue: _unref(richTemplate),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(richTemplate) ? (richTemplate).value = $event : null)),
              init: {
            height: 200,
            menubar: true,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount',
            ],
            toolbar:
              'undo redo | formatselect | bold italic backcolor | \ alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat | help',
            menu: {
              file: {
                title: 'File',
                items: 'newdocument restoredraft | preview ',
              },
              edit: {
                title: 'Edit',
                items: 'undo redo | cut copy paste | selectall | searchreplace',
              },
              view: {
                title: 'View',
                items:
                  'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen',
              },
              insert: {
                title: 'Insert',
                items:
                  'image link media template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime',
              },
              format: {
                title: 'Format',
                items:
                  'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | removeformat',
              },
              tools: {
                title: 'Tools',
                items: 'spellchecker spellcheckerlanguage | code wordcount',
              },
              table: {
                title: 'Table',
                items: 'inserttable | cell row column | tableprops deletetable',
              },
              help: { title: 'Help', items: 'help' },
            },
          }
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataParameters), (param, index) => {
        return (_openBlock(), _createBlock(_component_va_chip, {
          key: index,
          color: param.source == 'system' ? 'warning' : 'success',
          style: {"font-size":"x-small"},
          size: "small",
          class: "mr-1 mb-1",
          onClick: ($event: any) => (parameterClick(param))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(param.name), 1)
          ]),
          _: 2
        }, 1032, ["color", "onClick"]))
      }), 128))
    ])
  ]))
}
}

})